import {madnes_set_audio_volume} from "../framework/src/engine/madnes/madnes_audio";
import {MadnesInterface} from "./libs/mi/MadnesInterface";
import {ServerConfig} from "./ServerConfig";
import Game from "./game/Game";
import GameInfo from "./game/GameInfo";
import GameConfig from "./game/GameConfig";
import SymbolsManager from "./symbol/SymbolsManager";
import GameAssets from "./game/GameAssets";
import GameGroups from "./game/GameGroups";
import SpinReels from "./reel/SpinReels";
import {to_load_audio} from "./adapters/madnesAssetsAdapter";
import {GameMemory} from "./game/GameMemory";
import {GameBonus} from "./game/GameBonus";
import GameWild from "./game/GameWild";
import AnimsBoomSpins from "./game/AnimsBoomSpins";
import AnimsWinCounter from "./game/AnimsWinCounter";
import AnimsBigWinCounter from "./game/AnimsBigWinCounter";
import GameHeader from "./game/GameHeader";

document.addEventListener(window.visibilityChange, playPauseGame, false);

var gameReady = false;

/** @type MadnesInterface  */
export var MI = new MadnesInterface();
MI.init();

/** @type {ServerConfig} */
var serverConfig = new ServerConfig();

export var game = new Game();

//game.ready = false;

export var gameInfo = new GameInfo();
export var gameConfig = new GameConfig();
export var symbolsManager = new SymbolsManager();

function playPauseGame()
{
	if(main_phaser) {

		if(document[hiddenName]) {
			main_phaser.paused = true;
		} else {
			main_phaser.paused = false;
		}
	}
}

/**
 * @param {string} dname
 * @param {Object=} config
 * @param {number=} ver
 */
function init_game(dname, config, ver) {

	if(typeof ver === 'undefined') {
		ver = 1;
	}

	// MI.setTextureVersion(ver);
	// MI.setNativeScreenSize(1280, 720);

	// madnes_config_load_symbols = false;

//	madnes_set_def_lang('en');
// 	madnes_load_init("joker_boom_plus", config);

	// for(var i in to_load) {
	// 	madnes_add_to_load(i, to_load[i]);
	// }
    //
	// delete to_load_fonts_madnes["win_font"];
	// delete to_load_madnes['coin_sprite'];
	// delete to_load_madnes['win_font_bg'];

	// for(var i in to_load_json_atlas) {
	// 	madnes_add_json_atlas_to_load(i, to_load_json_atlas[i][0], to_load_json_atlas[i][1]);
	// }
    //
	// for(var i in to_load_spritesheets) {
	// 	madnes_add_spritesheet_to_load(i, to_load_spritesheets[i]['url'], to_load_spritesheets[i]['w'], to_load_spritesheets[i]['h']);
	// }
    //
	// for(var i in to_load_fonts) {
	// 	madnes_add_font_to_load(i, to_load_fonts[i]);
	// }
    //
	// for(var i in to_load_json)
	// {
	// 	if(infotexts_languages.indexOf(lang) === -1)
	// 	{
	// 		to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
	// 	}
    //
	// 	madnes_add_json(i, to_load_json[i]);
	// }
    //
	// for(var i in to_load_audio) {
	// 	madnes_add_audio(i, to_load_audio[i]);
	// }

// 	//madnes_set_load_complete_function(ctrl_init_bonus);
//
// 	madnes_set_printdesk_function(init_desk);
// //	madnes_set_updatedesk_function(function() {});
//
// 	madnes_set_rotate_function(rotateRun);
//
// 	madnes_set_infomenu_init_function(infomenuInit);
// 	madnes_set_infomenu_update_function(infomenuUpdate);
// 	madnes_set_infomenu_open_function(infomenuOpen);
// 	madnes_set_infomenu_close_function(infomenuClose);
// 	madnes_set_infomenu_left_function(infomenuLeft);
// 	madnes_set_infomenu_right_function(infomenuRight);
//
// 	madnes_set_sound_yes_function(sound_choose);
// 	madnes_set_sound_no_function(sound_choose);
//
// 	madnes_set_on_rotate_press(rotatePress);
//
// 	madnes_set_game_ready_function(function() {
// 		//game.ready = true;
// 		if(is_last_round_autostart()) {
// 			madnes_rotate_start();
// 		}
// 	});

	/*
	madnes_set_betmenu_choose_function(betmenu_choose);
	madnes_set_betmenu_open_function(betmenu_open);*/
	//madnes_set_on_key_down_function(infomenuUpdate);
//	madnes_set_on_key_bet_change(infomenuUpdate);


	madnes_init(dname);
}
window["init_game"] = init_game;


function sound_choose() {
	game.wild.resetMemIndex(); //anim locked wild
};

export function jbp_init_desk() {

	serverConfig.setServerConfig(MI.server.getConfig());

	MI.setBigWinFactors(
		serverConfig.getMinBigWinFactor(),
		serverConfig.getMinMegaWinFactor(),
		serverConfig.getMinSuperMegaWinFactor()
	);

	/*if(serverConfig.getBetSet()) {
		//madnes_init_bets(serverConfig.getBetSet());
	}*/

	configSounds(serverConfig);
	configBehav(gameConfig, serverConfig);
	createGame();
}

function createGame() {

	MI.recountBet();

	var gameAssets = new GameAssets();
	var gameGroups = new GameGroups();
	var spinReels = new SpinReels();

	if(serverConfig.getLastRound()) {
		game.lastRoundEnded = serverConfig.getLastRound()["ended"];
	}

	game.init(spinReels, gameConfig, serverConfig, symbolsManager, gameAssets, gameGroups);

	game.sounds = initSounds();

	game.memory = new GameMemory();
	game.memory.init(serverConfig);

	game.bonus = new GameBonus();
	game.bonus.init(game);

	gameAssets.bg = MI.addImg(0, 0, "reels_background");
	gameAssets.bgBonus = MI.addImg(0, 0, "boomspins_atlas").setFrameName("background_boom-spins");
	gameAssets.bgBonus.setVisible(false);

	for(var i = 0; i < gameConfig.reelsPositions.length; i++) {
		gameGroups.create("group_symbols_" + i);
	}

	gameAssets.createBlackScreen();
	gameAssets.createWinLines(gameConfig, gameGroups);

	for(var i = 0; i < gameConfig.reelsPositions.length; i++) {
		gameGroups.create("group_symbols_anims_" + i);
	}

	gameAssets.createParticles();

	spinReels.init(gameConfig, serverConfig, symbolsManager, gameGroups);
	spinReels.setServerReels(serverConfig.getReels());
	spinReels.createReels();

	game.wild = new GameWild();
	game.wild.create(game);

	gameGroups.create("group_bw_particles");

	gameGroups.create("group_pre_cover");

	MI.addImg(0, 0, "reels_atlas").setFrameName("cover_top");
	MI.addImg(0, 110, "reels_atlas").setFrameName("cover_left");
	MI.addImg(MI.getWi(), 110, "reels_atlas").setFrameName("cover_right").setAnchor(1, 0);
	MI.addImg(0, MI.getHe(), "reels_atlas").setFrameName("cover_bottom").setAnchor(0, 1);

	gameGroups.create("group_post_cover");

	gameAssets.createLightCover(gameGroups);

	MI.addImg(0, MI.getHe() / 2, "reels_atlas").setFrameName("81_left").setAnchor(0, 0.5);
	MI.addImg(MI.getWi(), MI.getHe() / 2, "reels_atlas").setFrameName("81_right").setAnchor(1, 0.5);

	game.bonus.createReels();

	gameAssets.boomSpins = new AnimsBoomSpins();
	gameAssets.boomSpins.create(game);

	gameGroups.create("group_coins");
	gameAssets.createCoinsEmitter(gameGroups);

	gameAssets.animWinCounter = new AnimsWinCounter();
	gameAssets.animWinCounter.create();

	gameAssets.header = new GameHeader();
	gameAssets.header.create();

	gameAssets.bigWin = new AnimsBigWinCounter();
	gameAssets.bigWin.create(game);

	game.bonus.checkEnd();
	game.wild.checkWild();

//	infomenuInit();
//	infomenuOpen();
}

var timeEvents = [];

function rotatePress() {
//	game.spinPressed();
}

function reviveGame() {}

export function infomenuInit() {
	gameInfo.init(serverConfig);
    gameInfo.create();
}

export function infomenuUpdate() {

	if(!game || !game.bonus || !game.wild) {
		return;
	}

	game.bonus.checkEnd();
	game.wild.checkWild();


//	setTimeout(function() {
//		game.bonus.checkEnd();
//		game.wild.checkWild();
//	}, 10);

	gameInfo.update(MI.getBet());
}

export function infomenuOpen() {
	gameInfo.update(MI.getBet());
	gameInfo.open();
}

export function infomenuClose() {
	gameInfo.close();
	// gameInfo.destroy();
}

export function infomenuLeft() {
	gameInfo.slideLeft();
}

export function infomenuRight() {
	gameInfo.slideRight();
}

export function infomenuHome() {
	gameInfo.showMain();
}

export function rotateRun() {
	game.spinStart();
}

/**
 * @returns {Object<string,MadnesAudio>}
 */
export function initSounds() {
	var sounds = {};

	for(var audioName in to_load_audio) {
		sounds[audioName] = MI.addAudio(audioName);
	}

	sounds["reel_stop"].allowMultiple();
	sounds["symbol_joker"].allowMultiple();
	sounds["symbol_star"].allowMultiple();

	sounds["remittance_A"] = MI.addAudio("remittance_A").allowMultiple();

	return sounds;
};

/**
 * @param {GameConfig} gameConfig
 * @returns {undefined}
 */
function configBehav(gameConfig, serverConfig) {

	if(serverConfig.getAutoStartDelay()) {
		gameConfig.autoStartDelay = serverConfig.getAutoStartDelay();
	}
}

/**
 * @param {ServerConfig} serverConfig
 */
function configSounds(serverConfig) {
	var vol = 1;

	vol = serverConfig.getVolumeBigWin();
	madnes_set_audio_volume('audio_big_win_explosion', vol);
	madnes_set_audio_volume('audio_big_win', vol);
	madnes_set_audio_volume('audio_mega_win', vol);
	madnes_set_audio_volume('audio_big_win_end', vol);

	vol = serverConfig.getVolumeButtonEffect();
	madnes_set_audio_volume('button_click', vol);
	madnes_set_audio_volume('bonus_pick', vol);

	vol = serverConfig.getVolumeSpin();
	madnes_set_audio_volume("reel_spin", vol);

//	vol = serverConfig.getVolumeStartReel();

	vol = serverConfig.getVolumeStopReel();
	madnes_set_audio_volume("reel_stop", vol);

	vol = serverConfig.getVolumeWinAnim();
	madnes_set_audio_volume('win_low_1', vol);
	madnes_set_audio_volume('win_low_2', vol);
	madnes_set_audio_volume('win_low_3', vol);
	madnes_set_audio_volume('win_low_4', vol);

	madnes_set_audio_volume('win_high_1', vol);
	madnes_set_audio_volume('win_high_2', vol);
	madnes_set_audio_volume('win_high_3', vol);
	madnes_set_audio_volume('win_high_4', vol);

	madnes_set_audio_volume("win_stars", vol);
	madnes_set_audio_volume("bonus_joker", vol);

	vol = serverConfig.getVolumeWinCounter();
	madnes_set_audio_volume("remittance_A", vol);
	madnes_set_audio_volume("remittance_B", vol);

//	vol = serverConfig.getVolumeBackground();
//	vol = serverConfig.getVolumeFSBackground();
//
	vol = serverConfig.getVolumeBonusBackground();
	madnes_set_audio_volume("audio_bonus_bg", vol);

	vol = serverConfig.getVolumeMiscSound1();
	madnes_set_audio_volume("coins_loop", vol);

	vol = serverConfig.getVolumeMiscSound2();
	madnes_set_audio_volume("symbol_joker", vol);
	madnes_set_audio_volume("bonus_start", vol);
	madnes_set_audio_volume("bonus_end", vol);

	vol = serverConfig.getVolumeMiscSound3();
	madnes_set_audio_volume("symbol_star", vol);

//	vol = serverConfig.getVolumeMiscSound4();
//	vol = serverConfig.getVolumeMiscSound5();
}